var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"num-span",attrs:{"data-time":_vm.time,"data-value":_vm.value}},[_vm._v(_vm._s(_vm.addNum))])
}
var staticRenderFns = []

export { render, staticRenderFns }